<template>
	<div class="character">
		<div class="bg-cork"></div>
		<div class="strings"></div>
		<div class="post-mark"></div>
		<router-link @click="toTop" to="/" class="desktop-keys">
			<div class="keys"></div>
		</router-link>
		<cc />
		<div class="vertical-string">
			<div class="media-wrapper">
				<div class="ch-photo"></div>

				<div class="player-wrapper" :class="{ 'disabled': audioUrl.length === 0 }">
					<AudioPlayer id="player1" :file="audioUrl" class="player"></AudioPlayer>
					<div class="label"><span>{{ lang('listen') }}</span></div>
				</div>
				<VDropdown :distance="-20" strategy="fixed" :shown="vPopperOpen" @show="popperShowHandler('read-more')"
					@hide="popperHideHandler('read-more')">
					<!-- This will be the popover target (for the events and position) -->
					<div class="read-icon-wrapper"
						:class="{ 'disabled': readMore.length === 0, 'animate': readMore.length > 0 }">
						<div class="read-icon-1"></div>
						<div class="read-icon-2"></div>
						<div class="read-icon-3"></div>
						<div class="label"><span>{{ lang('read') }}</span></div>
					</div>
					<!-- This will be the content of the popover -->
					<template #popper>
						<div class="read-popper">
							<a class="popper-closer" @click="popperClose('read-more')" v-close-popper><i
									class="fas fa-times-circle"></i></a>
							<vanessaText :popper-open="vPopperOpen" />
						</div>
					</template>
				</VDropdown>

				<VDropdown :distance="-20" strategy="fixed" :shown="vEvidencePopperOpen" @show="popperShowHandler('evidence')"
					@hide="popperHideHandler('evidence')">
					<div class="evidence-icon"
						:class="{ 'empty-evidence': $evidence.value === null, 'animate': $evidence.value !== null }">
						<div class="label"><span>{{ lang('evidence') }}</span></div>
					</div>

					<!-- This will be the content of the popover -->
					<template #popper>
						<div class="evidence-popper">
							<a class="popper-closer" @click="popperClose('evidence')" v-close-popper><i
									class="fas fa-times-circle"></i></a>
							<VanessaEvidence />
						</div>
					</template>
				</VDropdown>

			</div>
		</div>

		<div class="character-d" scroll="no">
			<TopTextBox :items="textBoxData" />

			<red_overlay id="redoverlay" />

			<div id="line-1">
				<slide1 id="slide1" />
				<slide2 id="slide2" />
				<slide3 id="slide3" />
				<slide5 id="slide5" />
				<slide7_1 id="slide7_1" />
				<slide8 id="slide8" />
				<slide9 id="slide9" />
				<slide11 id="slide11" />
				<slide15 id="slide15" />
				<slide21_1 id="slide21_1" />
				<slide22 id="slide22" />
				<slide26 id="slide26" />
				<slide27 id="slide27" />
				<slide28 id="slide28" />
				<slide29 id="slide29" />
				<slide31 id="slide31" />
			</div>

			<house id="house" />

			<div id="line-2">
				<slide6 id="slide6" />
				<slide7 id="slide7" />
				<slide10 id="slide10" />
				<slide12 id="slide12" />
				<slide21 id="slide21" />
				<slide23 id="slide23" />
				<slide30 id="slide30" />
			</div>

			<slide13 id="slide13" />
			<slide14_1 id="slide14_1" />
			<slide14_2 id="slide14_2" />
			<slide14_3 id="slide14_3" />
			<slide14_4 id="slide14_4" />

			<slide16 id="slide16" />
			<slide17 id="slide17" />
			<slide18 id="slide18" />
			<slide19 id="slide19" />

			<slide20 id="slide20" />

			<slide24 id="slide24" />
			<slide25 id="slide25" />

			<ControlsButton class="vanessa-controls-button" :data="controlsButtonData" />
			<cc-control></cc-control>
			<langControl/>
			<black_overlay id="black_overlay" :overlay="overlay" />
			<outro id="outro" :outro="outro" />

		</div>

	</div>
</template>

<script>
import AudioPlayer from '../../components/audioPlayer.vue';
import vanessaText from '../components/ReadMore.vue';
import evidence from '../components/evidence';
import ControlsButton from '../../components/controlsButton';
import controlsButtonData from './vanessa/controlsButtonData';
import textBoxData from './vanessa/text-box';
import cc from '../../components/cc.vue'
import cc_control from '../../components/cc_control.vue'
import langControl from '../../components/langControl.vue'

import slide1 from './vanessa/slide1.vue';
import slide2 from './vanessa/slide2.vue';
import slide3 from './vanessa/slide3.vue';
import house from './vanessa/slide4.vue';
import slide5 from './vanessa/slide5.vue';
import slide6 from './vanessa/slide6.vue';
import slide7 from './vanessa/slide7.vue';
import slide7_1 from './vanessa/slide7_1.vue';
import slide8 from './vanessa/slide8.vue';
import slide9 from './vanessa/slide9.vue';
import slide10 from './vanessa/slide10.vue';
import red_overlay from './vanessa/red_overlay.vue';
import slide11 from './vanessa/slide11.vue';
import slide12 from './vanessa/slide12.vue';
import slide13 from './vanessa/slide13.vue';
import slide14_1 from './vanessa/slide14_1.vue';
import slide14_2 from './vanessa/slide14_2.vue';
import slide14_3 from './vanessa/slide14_3.vue';
import slide14_4 from './vanessa/slide14_4.vue';
import slide15 from './vanessa/slide15.vue';
import slide16 from './vanessa/slide16.vue';
import slide17 from './vanessa/slide17.vue';
import slide18 from './vanessa/slide18.vue';
import slide19 from './vanessa/slide19.vue';
import slide20 from './vanessa/slide20.vue';
import slide21 from './vanessa/slide21.vue';
import slide21_1 from './vanessa/slide21_1.vue';
import slide22 from './vanessa/slide22.vue';
import slide23 from './vanessa/slide23.vue';
import slide24 from './vanessa/slide24.vue';
import slide25 from './vanessa/slide25.vue';
import slide26 from './vanessa/slide26.vue';
import slide27 from './vanessa/slide27.vue';
import slide28 from './vanessa/slide28.vue';
import slide29 from './vanessa/slide29.vue';
import slide30 from './vanessa/slide30.vue';
import slide31 from './vanessa/slide31.vue';
import outro from './outro.vue';
import black_overlay from './black_overlay.vue';
import TopTextBox from '../components/TopTextBox';

export default {
	name: 'vanessa',
	inject: ['helpers', 'lang'],
	components: {
		ControlsButton,
		AudioPlayer,
		vanessaText,
		'VanessaEvidence': evidence,
		TopTextBox,
		cc,
		'cc-control': cc_control,
		langControl,
		slide1,
		slide2,
		slide3,
		house,
		slide5,
		slide6,
		slide7,
		slide7_1,
		slide8,
		slide9,
		slide10,
		red_overlay,
		slide11,
		slide12,
		slide13,
		slide14_1,
		slide14_2,
		slide14_3,
		slide14_4,
		slide15,
		slide16,
		slide17,
		slide18,
		slide19,
		slide20,
		slide21,
		slide21_1,
		slide22,
		slide23,
		slide24,
		slide25,
		slide26,
		slide27,
		slide28,
		slide29,
		slide30,
		slide31,
		outro,
		black_overlay,
	},
	created() {
		this.$watch('$audioUrl.value', (newVal) => {
			this.setAudioUrl(newVal);
		}, { immediate: true });
		this.$watch('$readMore.value', (newVal) => {
			this.setReadMore(newVal);
		}, { immediate: true });
		this.$watch('$evidence.value', (newVal) => {
			this.setEvinence(newVal);
		}, { immediate: true });
	},
	mounted() {
		window.document.querySelector('html').scrollTo({
			top: 0,
			behavior: "smooth"
		});
		setTimeout(() => {
			this.helpers.enableScrolling();
		}, 1000);

	},
	methods: {
		setAudioUrl(value) {
			this.audioUrl = value;
		},
		setEvinence(value) {
			if (value !== null) {
				this.vEvidencePopperOpen = false;
			}
		},
		setReadMore(value) {
			this.readMore = value;
			if (!this.readMore.length) {
				this.vPopperOpen = false;
			}
		},
		popperShowHandler(type) {
			if (type == 'read-more') {
				this.vEvidencePopperOpen = false;
				this.vPopperOpen = true;
			} else if (type == 'evidence') {
				this.vPopperOpen = false;
				this.vEvidencePopperOpen = true;
			}

			setTimeout(() => {
				if (type == 'evidence') {
					document.querySelector('.v-popper__popper--shown').classList.remove('read-more');
				}
				if (type == 'read-more') {
					document.querySelector('.v-popper__popper--shown').classList.remove('evidence');
				}
				document.querySelector('.v-popper__popper--shown').classList.add(type);
			}, 100);
		},
		popperHideHandler(type) {
			this.popperClose(type);
			setTimeout(() => {
				if(document.querySelector('.v-popper__popper--shown') && type && type.length) {
					document.querySelector('.v-popper__popper--shown').classList.remove(type);
				}
			}, 100);

		},
		popperClose(type) {
			if (type == 'read-more') {
				this.vPopperOpen = false;
			} else if (type == 'evidence') {
				this.vEvidencePopperOpen = false;
			}
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}

	},
	data() {
		return {
			controlsButtonData,
			textBoxData,
			showModal: false,
			audioUrl: '',
			vPopperOpen: false,
			vEvidencePopperOpen: false,
			readMore: '',

			/*outro: [
				{
					start: 41800,
					end: 42500,
					fromStyle: { transform: window.innerWidth < 600 ? 'rotate(90deg) translateX(1800px) translateY(-70px)' : 'translateY(1800px)', opacity: 0.8 },
					toStyle: { transform: window.innerWidth < 600 ? 'rotate(90deg) translateX(0) translateY(0px)' : 'translateY(0px)', opacity: 1 }
				}
			],*/

			outro: [
				{
					start: 41800,
					end: 42500,
					fromStyle: { bottom: '-150%', opacity: 0.8 },
					toStyle: { bottom: '0%', opacity: 1 }
				}
			],

			overlay: [
				{
					start: 41800,
					end: 42500,
					fromStyle: { opacity: '0' },
					toStyle: { opacity: '0.9' },
					easing: 'linear'
				}
			]
		};
	}
};
</script>


<style lang="scss">
html {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;

	/* Firefox */
	&::-webkit-scrollbar {
		display: none;
	}
}

.next-button-wrapper {
	position: fixed;
	width: 100%;
	z-index: 1000;
}
.vanessa-controls-button {
	bottom: 59px !important;
}
.character {
	.post-mark {
		position: fixed;
		right: -55px;
		top: -50px;
		z-index: 5;
		background-image: url('/themes/rise-theme/dist/images/estate/character-view/post-mark-1.png');
		background-position: top right;
		background-repeat: no-repeat;
		background-size: cover;
		width: 170px;
		height: 170px;

		@media(max-width: 600px) {
			display: none;
			width: 170px;
			height: 170px;
			right: -53px;
		}

		@media(max-width: 400px) {
			width: 110px;
			height: 120px;
			right: -43px;
			top: -40px;
		}
	}

	.desktop-keys {
		display: none;

		@media(min-width: 600px) {
			display: inline-block;
		}
	}

	.keys {
		position: fixed;
		right: 35px;
		top: 0;
		background-image: url(/themes/rise-theme/dist/images/estate/about/About_Background_Keys.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		width: 180px;
		height: 226px;
		z-index: 100;
		cursor: pointer;
	}

	@media(max-width: 400px) {
		.ch-photo {
			height: 90px !important;
			width: 70px !important;
		}
	}

}

.character-d {
	height: 45000px;
	color: white;
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
}

.read-icon-wrapper {
	&.disabled {
		pointer-events: none;
		filter: brightness(0.5);
	}
}

#line-1 {
	position: fixed;
	left: calc(50% + 29vh);
	transform: rotateZ(6deg);
	height: 100vh;
	top: 0;
	z-index: 3;

	@media(max-width: 600px) {
		left: calc(57% + 30px);
	}

	@media(max-width: 480px) {
		left: calc(50% + 60px);
	}
}

#line-2 {
	position: fixed;
	left: calc(50% - 16vh);
	transform: rotateZ(-11.7deg);
	height: 100vh;
	top: 0;
	z-index: 3;

	@media(max-width: 600px) {
		left: calc(48% - 60px);
	}

	@media(max-width: 480px) {
		left: calc(50% - 60px);
	}
}

@media screen and (max-width: 750px) {
	.character-d #slide27 .photo1 {top: 0;}
	.character-d #slide30 .photo1 {top: 0;}
	.character-d #slide29 .photo1 {top: 0;}
	.character-d #slide31 .photo1 {top: 250px;}
}

@media screen and (max-width: 375px) and (max-height: 667px) {
	.character-d #slide27 .photo1 {top: -70px;}
	.character-d #slide30 .photo1 {top: -20px;}
	.character-d #slide29 .photo1 {top: -120px;}
}

@media screen and (max-width: 650px) and (max-height: 715px) {
	.character-d #slide27 {top: -100px;}
	.character-d #slide31 .photo1 {top: 200px;}
}

@media screen and (max-width: 991px) and (orientation: landscape) {
	.character-d #slide18 {zoom: 0.26 !important;}
	.character-d #slide31 .photo1 {top: 300px;}
}
</style>

